/**
 * Created by Christof Sander on 22.09.2016.
 */

const utils = require('frontend-controller/lib/utils');
var store = require('frontend-controller/lib/store');



module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		checkForBrowserFills: true,
		isLoginDialog: false,
		resetDirtyFieldsAfterSuccessfulSubmit: false,
		onSubmitDonePanelMessage: '',
		statusControllerLoadingMessage: '',
		statusControllerSavingMessage:  'status.progress.login'
	},

	methods: {
		/**
		 * this function is used to handle the different kinds of errors.
		 * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
		 * NOTE: if this function resolves the given context is allways the original context and NOT the error handling context.
		 *
		 * @param   context             {} - action perform context
		 *          {
	     *              component: ...
	     *              [action]: ...
	     *              error: {
	     *                  statusCode: <statusCode>            mixed - status code || 'clientError'
	     *                  name: <statusCode>                  string - error name
	     *                  errorCode: <statusCode>             string - error code
	     *                  message: <statusCode>               string - error message
	     *                  details: <statusCode>               string - error details
	     *                  [childErrors]: []                   [] - list of child errors
	     *              },
	     *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
		 *                                      int - this error handling type defines the state of error handling
	     *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
	     *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
	     *          }
		 * @returns Promise
		 */
		handleError: function(context){
			var baseError = utils.extractBaseError(context.error);

			if(baseError.statusCode == 403){
				if(
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_1'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_2'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_3'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_4'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_5'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_1'
					||
					baseError.errorCode == 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_2'
					||
					baseError.errorCode == 'LOCAL_USERMANAGEMENT_PROVIDER_LOGIN_ERROR'
				){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:login.invalidUserData'
							}
						}, {
							rollbackContext: context,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}
			}
			else if(baseError.statusCode == 400){
				if(baseError.errorCode == 'USERMANAGEMENT_LOGIN_PARAMETER_ERROR'){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:login.inCompleteUserData'
							}
						}, {
							rollbackContext: context,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		/**
		 * this function will be called after the response of a submit request has returned.
		 *
		 * @param   response        {} - server response
		 */
		onSubmit: function(response){
			store.set(response);

			if(this.config.isLoginDialog && !this.resourceData.forcePageRefresh){
				if(store.get().user.data.states.authenticated){
					var resource = this.getResourceRegisterContent('loginForm');
					if(resource && resource.actionContext) {
						// resource.actionContext.action.reperformPromiseChain = true;
						// if(resource.actionContext._self) resource.actionContext._self.resolve(resource.actionContext);
						if(resource.actionContext.action && resource.actionContext.action.reperformAction){
							resource.actionContext.component.performAction(resource.actionContext.action);
						}
					}
				}

				return this.triggerClosest('onDecision', {
					decisionComponent: this,
					decisionType: 'cancel'
				});
			}
			else {
				window.location.href = window.location.href;
			}
		}
	},

	hooks: {
		onDecision: function($element, options){
			var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
			if(modalContentComponent.hasClass('templates_login_container')){
				this.submit();
			}
		}
	}
};